<h1 mat-dialog-title>Add Observation Type</h1>

<form #form="ngForm">
	<mat-dialog-content class="dialog-content">
		<div>
			<mat-form-field appearance="outline" color="accent" class="mat-form-field">
				<mat-label>Title</mat-label>
				<input matInput
					   autocomplete="off"
					   name="title"
					   [(ngModel)]="data.title"
					   minlength="1"
					   maxlength="255"
					   required
					   cdkfocusinitial>
			</mat-form-field>
		</div>

		<div>
			<mat-form-field appearance="outline" color="accent" class="mat-form-field">
				<mat-label>Alias</mat-label>
				<input matInput
					   autocomplete="off"
					   name="abbreviation"
					   required
					   [(ngModel)]="data.abbreviation"
					   maxlength="10"
				>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions>
		<button mat-button mat-dialog-close>
			Cancel
		</button>
		<button mat-flat-button
				type="submit"
				[mat-dialog-close]="data"
				[disabled]="form.invalid">
			Add type
		</button>
	</mat-dialog-actions>
</form>
